<div class="main-content table-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Indicadores generales <span *ngIf="anio">· {{ anio }}</span></h1>
        <p>Avance por norma al corte {{ corte === 'ANUAL' ? 'anual' : 'Q' + corte }}.</p>
      </div>
      <a mat-button routerLink="/admin/bsc/tablero" [queryParams]="{ anio: anio, corte: corte }">Volver al tablero</a>
    </section>
    <app-selector-corte-bsc prefijo="bsc-indicadores" [anio]="anioInicial" [corte]="corteInicial"
      [deshabilitado]="exportando" (cambio)="onSeleccion($event)"></app-selector-corte-bsc>
    <nav class="indicadores-normas" aria-label="Normas">
      <button type="button" mat-button [attr.aria-pressed]="idNorma == null" (click)="elegirNorma()" [disabled]="exportando">Todas ({{ total }})</button>
      <button type="button" mat-button *ngFor="let n of normas" [attr.aria-pressed]="idNorma === n.idNorma"
        [disabled]="exportando" (click)="elegirNorma(n.idNorma)">{{ n.nombre }} ({{ n.total ?? 0 }}){{ n.activa === false ? ' · Inactiva' : '' }}</button>
    </nav>
    <output *ngIf="loading" class="d-block mb-3">Consultando indicadores…</output>
    <div *ngIf="error" class="bsc-franja" role="alert">{{ error }} <button type="button" mat-button (click)="consultar()">Reintentar</button></div>
    <ng-container *ngIf="!loading && !error && anio">
      <section class="table-page__card">
        <div class="table-page__empty" *ngIf="filas.length === 0">
          <h2>Sin indicadores en {{ anio }}</h2>
          <p>Esta selección no tiene KPI definidos. Calidad puede elegirlos en Parámetros BSC.</p>
        </div>
        <div class="table-page__table-wrap" *ngIf="filas.length > 0">
          <table class="table-page__table">
            <caption class="bsc-oculto">Indicadores por norma. Los trimestres muestran unidades de la meta o porcentaje acumulado si no hay valor.</caption>
            <thead><tr><th scope="col">Objetivo</th><th scope="col">Área</th><th scope="col">Meta</th>
              <th scope="col">Q1</th><th scope="col">Q2</th><th scope="col">Q3</th><th scope="col">Q4</th>
              <th scope="col">Alcance al corte</th><th scope="col">Avance trimestral (%)</th></tr></thead>
            <tbody><tr *ngFor="let f of filas">
              <td><div class="table-page__cell-stack"><strong>{{ f.objetivo }}</strong><span>{{ f.indicador }}</span>
                <span class="table-page__subtext" *ngIf="idNorma == null">{{ f.norma }}</span></div></td>
              <td>{{ f.area }}</td><td>{{ f.meta }}</td><td *ngFor="let q of f.trimestres">{{ q }}</td>
              <td><span>{{ f.alcance }}</span><div class="indicador-pista" aria-hidden="true"><i [style.width.%]="f.ancho"></i></div>
                <span *ngIf="f.estado as estado" class="table-page__status-badge" [ngClass]="estado.clase">{{ estado.texto }}</span>
                <span *ngIf="!f.estado">Sin dato</span></td>
              <td><app-avance-indicador-bsc [real]="f.real" [nombre]="f.objetivo"></app-avance-indicador-bsc></td>
            </tr></tbody>
          </table>
        </div>
      </section>
      <section class="table-page__card indicadores-auditoria">
        <h2>Para la auditoría</h2>
        <p>{{ idNorma == null ? 'Última lista definida' : 'Lista definida' }} por {{ definidaPor }} · {{ definidaEl }}</p>
        <p *ngIf="idNorma == null">Elige una norma para consultar su definición y exportar evidencia.</p>
        <button type="button" mat-raised-button class="app-form-btn app-form-btn--primary" [disabled]="idNorma == null || exportando" (click)="exportar()">
          {{ exportando ? 'Exportando…' : 'Exportar evidencia (Excel)' }}
        </button>
        <p role="alert" *ngIf="errorExportar">{{ errorExportar }}</p>
      </section>
    </ng-container>
  </div>
</div>
